<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Inventario de Productos</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                              :item-class="stockCeroBackground"
                            >
                              <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>

          <v-btn
            fab
            fixed
            bottom
            right
            color="green"
            dark
            style="bottom: 90px"
            @click="domwloadExcel()"
          >
            <v-icon>description</v-icon>
          </v-btn>

          <v-btn
            fab
            fixed
            bottom
            right
            color="green"
            dark
            style="bottom: 20px"
            @click="domwloadInventoryAmountExcel()"
          >
            <v-icon>widgets</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'InventoryView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        panel: [0],
        search: '',
        headers: [
          { text: 'PROVEEDOR', value: 'order_supplier.supplier_name'},
          { text: 'PRODUCTO', value: 'product.name'},
          { text: 'COLOR', value: 'product_color.color.name' },
          { text: 'SIZE', value: 'product_color_size.size.name'},
          { text: 'STOCK INICIAL', value: 'initial_stock' },
          { text: 'STOCK ACTUAL', value: 'stock' },
          { text: 'COSTO ENVÍO UNI.', value: 'unit_freight_price' },
          { text: 'COSTO PRODUCTO UNI.', value: 'unit_product_price' },
          { text: 'TOTAL COSTO PRODUCTO UNI.', value: 'total_unit_product_price' },
          { text: 'FECHA CREACIÓN', value: 'created_at' }
        ],
        items: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      formatDate: function(date) {
        return moment(date).format("DD MMMM YYYY");
      },

      stockCeroBackground: function (item) {
        return item.stock == 0 ? 'row-stock' : ''
      },

      getInventories() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_INVENTORIES)
        .then(response => {
          this.items = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadExcel() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_INVENTORIES, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/xls'
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadInventoryAmountExcel() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_INVENTORIES_AMOUNT, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/xls'
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getInventories();
    }
  }
</script>
<style>
  .row-stock {
    background-color: #ff000040
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/Inventory.vue